// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nextpax-dropdown[data-v-23ecba74] .buttons-wrapper{width:100%}.toggle-feed[data-v-23ecba74]{width:105px}.important-text[data-v-23ecba74]{max-width:30%;display:block}", ""]);
// Exports
module.exports = exports;
